import { render } from "./StoryblokRenderer.vue?vue&type=template&id=6c96b04c&scoped=true"
import script from "./StoryblokRenderer.vue?vue&type=script&lang=js"
export * from "./StoryblokRenderer.vue?vue&type=script&lang=js"

import "./StoryblokRenderer.vue?vue&type=style&index=0&id=6c96b04c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c96b04c"]])

export default __exports__